import { AttachmentsState } from './attachments.types'

export default (): AttachmentsState => ({
  data: {},
  filters: {}
})
